import { manhattanDistance } from "flatland/src/distance";
import Entity from "./entity";
import Fightable from "./fightable";
import Glyphs from "../glyphs";
import Component from "./component";
import Speed from "./speed";
import Mass from "./mass";
import Health from "./health";
import Equipment from "./equipment";
import Weapons from "./weapons";
import Items from "./items";
import Armor from "./armor";
import Statblock from "./statblock";
import Description from "./description";
import * as behaviour from "./behaviour";

import Tiles from "../tiles";

function euclidianDistance(start, end) {
  const a = start.x - end.x;
  const b = start.y - end.y;
  return Math.sqrt((a * a) + (b * b));
}

class TargetDroneSense {
  constructor() {
    this.chasing = false;
  }

  isEnemy() {
    return this.chasing;
  }

  bumpFrom(entity) {
    if (entity.isPlayer()) {
      this.chasing = true;
      return true;
    }
    return false;
  }

  takeTurn(stage) {
    if (this.chasing) {
      behaviour.meleeCharge(this.owner, stage.player, stage);
    } else {
      behaviour.drunkenWalk(this.owner, stage);
    }
  }
}

class GorgonGiantSense {
  constructor() {
    this.awakened = false;
  }

  isEnemy() {
    return true;
  }

  bumpFrom(entity) {
    return true;
  }

  takeTurn(stage) {
    if (stage.isVisible(this.owner.x, this.owner.y)) {
      this.awakened = true;
      const attackDistance = manhattanDistance(this.owner, stage.player);

      if (attackDistance <= 10) {
        this.owner.glyph = Glyphs.GorgonGiantAttack;
        stage.player.glyph = Glyphs.PlayerGiantGaze;

        // Petrifying gaze attack
        stage.player.gazeFrom(this.owner, attackDistance);
      } else {
        this.owner.glyph = Glyphs.GorgonGiant;
        stage.player.glyph = Glyphs.Player;
      }

      console.log("then charge")

      // Double attacks when player is adjacent in any tile
      behaviour.meleeCharge(this.owner, stage.player, stage);

    } else {
      if (this.awakened) {
        behaviour.meleeCharge(this.owner, stage.player, stage);
      } else {
        behaviour.drunkenWalk(this.owner, stage);
      }

      this.owner.glyph = Glyphs.GorgonGiant;
      stage.player.glyph = Glyphs.Player;
    }
  }
}

function spawnGorgonGiant(x, y) {
  return new Entity(x, y, Glyphs.GorgonGiant, "Gorgon Giant", {
    description: new Description("Horrific description of the stone giant"),
    mass: new Mass(Mass.Large),
    speed: new Speed(7),
    health: new Health(80),
    sense: new GorgonGiantSense(),
    stats: new Statblock(20, 8, 20),
    equipment: new Equipment(Weapons.giantFlail())
  })
}

function spawnTargetDrone(name, x, y) {
  return new Entity(x, y, Glyphs.TargetDrone, name, {
    description: new Description("Insensate automata drone for target practice."),
    mass: new Mass(Mass.Small),
    speed: new Speed(5),
    health: new Health(5),
    sense: new TargetDroneSense(),
    stats: new Statblock(12, 12, 12),
    equipment: new Equipment(Weapons.Spear, Armor.Leather)
  });
}

const CellTypes = {
  WALL: 0,
  FLOOR: 1
}

function generateTrainingHall() {
  const grid = [];
  const width = 30;
  const height = 30;

  for (let y=0; y < height; y++) {
    grid[y] = [];
    for (let x=0; x < width; x++) {
      if (x == 0 || y == 0 || x == width - 1 || y == height - 1) {
        grid[y][x] = CellTypes.WALL;
      } else {
        grid[y][x] = CellTypes.FLOOR;
      }
    }
  }

  grid[14][12] = CellTypes.WALL;
  grid[13][12] = CellTypes.WALL;
  grid[12][12] = CellTypes.WALL;
  grid[12][13] = CellTypes.WALL;
  grid[12][14] = CellTypes.WALL;
  grid[12][15] = CellTypes.WALL;
  grid[12][16] = CellTypes.WALL;
  grid[11][16] = CellTypes.WALL;
  grid[10][16] = CellTypes.WALL;

  const tiles = [];

  for (let y=0; y < height; y++) {
    tiles[y] = [];
    for (let x=0; x < width; x++) {
      switch (grid[y][x]) {
        case CellTypes.WALL:
          tiles[y][x] = Tiles.SlateRock4;
        break;
        case CellTypes.FLOOR:
          tiles[y][x] = Tiles.LimestoneCave;
        break;
      }
    }
  }

  tiles[3][7] = Tiles.LimestoneExit;

  const start = {
    x: width / 2,
    y: height / 2
  }

  return {
    tiles,
    portals: {
      start,
      exit: { x: 7, y: 3 }
    },
    features: {}
  }
}

export {
  generateTrainingHall,
  spawnTargetDrone,
  spawnGorgonGiant
}
